module.exports = __webpack_public_path__ + "img/icon-store.507c6d27.svg";